import axios from '../axios';
import type {
  ApiEnvelope,
  Identifier,
  PaginatedResponse,
  ProviderOpportunityDto,
  ProviderOpportunityParams,
} from './types';

const API_URL = '/v1/owner/manpro/opportunities';

const ownerOpportunityService = {
  async getOwnerOpportunities(params?: ProviderOpportunityParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderOpportunityDto> | ProviderOpportunityDto[]>>(
      API_URL,
      { params },
    );

    return response.data.content;
  },

  async getOwnerOpportunity(id: Identifier) {
    const response = await axios.get<ApiEnvelope<ProviderOpportunityDto>>(`${API_URL}/${id}`);
    return response.data.content;
  },

  async getFavoriteOwnerOpportunities(params?: Pick<ProviderOpportunityParams, 'limit' | 'offset' | 'search'>) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderOpportunityDto>>>(
      `${API_URL}/favorites`,
      { params },
    );

    return response.data.content;
  },

  async favoriteOwnerOpportunity(id: Identifier) {
    const response = await axios.post<ApiEnvelope<ProviderOpportunityDto>>(`${API_URL}/${id}/favorite`);
    return response.data.content;
  },

  async removeFavoriteOwnerOpportunity(id: Identifier) {
    const response = await axios.delete<ApiEnvelope<ProviderOpportunityDto>>(`${API_URL}/${id}/favorite`);
    return response.data.content;
  },
};

export default ownerOpportunityService;
